import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import AuthProvider, { useAuth } from "./utils/auth";

import Logo from "./assets/images/IndusindLogo.png";
import CarePlixLogo from "./assets/images/CarePlixLogo.png";

import { ReactComponent as LogoutIcon } from "./assets/icons/Logout.svg";

import GetStarted from "./screens/GetStarted";
import ValidateReferral from "./screens/ValidateReferral";
import Dashboard from "./screens/Dashboard";
import BasicDetails from "./screens/BasicDetails";
import SelectOption from "./screens/SelectOption";
import ScanInstructions from "./screens/ScanInstructions";
import HealthQuestionnaire from "./screens/HealthQuestionnaire";
import FaceScan from "./screens/FaceScan";
import FingerScan from "./screens/FingerScan";
import ScanResult from "./screens/ScanResult";
import History from "./screens/History";
import SampleReport from "./screens/SampleReport";
import AdminPanel from "./screens/AdminPanel";

const Header = () => {
  const { logoutAgent } = useAuth();

  return (
    <main className="min-h-screen relative bg-white">
      <header className="flex items-center justify-between p-6">
        <div className="flex items-center">
          <img className="flex-shrink-0 h-12" src={Logo} alt="logo" />
          <div className="w-px h-8 bg-gray-300 mx-3" />
          <div className="flex flex-col items-start">
            <span className="text-gray-500 text-xs leading-tight font-medium">Powered by</span>
            <img className="h-5 mt-0.5 object-contain" src={CarePlixLogo} alt="CarePlix" />
          </div>
        </div>
        <button
          className="flex-shrink-0 p-1.5 outline-none rounded-full bg-error/10"
          type="button"
          onClick={() => {
            if (window.confirm("Are you sure you want to Logout?")) logoutAgent();
          }}
        >
          <span className="sr-only">Logout</span>
          <LogoutIcon className="size-6 text-error" />
        </button>
      </header>
      <Outlet />
    </main>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <Header />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: "basic-details", element: <BasicDetails /> },
      { path: "select-option", element: <SelectOption /> },
      { path: "scan-instructions", element: <ScanInstructions /> },
      { path: "health-questionnaire", element: <HealthQuestionnaire /> },
      { path: "scan-result", element: <ScanResult /> },
      { path: "scan-history", element: <History /> },
    ],
  },
  {
    path: "face-scan",
    element: (
      <AuthProvider>
        <FaceScan />
      </AuthProvider>
    ),
  },
  {
    path: "finger-scan",
    element: (
      <AuthProvider>
        <FingerScan />
      </AuthProvider>
    ),
  },
  {
    path: "get-started",
    element: <GetStarted />,
  },
  {
    path: "sample-report",
    element: <SampleReport />,
  },
  {
    path: "admin",
    element: <AdminPanel />,
  },
  {
    path: "validate-referral",
    element: (
      <AuthProvider>
        <ValidateReferral />
      </AuthProvider>
    ),
  },
]);

const App = () => (
  <RouterProvider router={router} />
);

export default App;
